import {compareAsc, format, parse, startOfDay} from "date-fns";
import {utcToZonedTime, zonedTimeToUtc} from "date-fns-tz";

const DEFAULT_TIMEZONE = 'America/Phoenix';

function formatFromISO(iso8601, formatString) {
    return format(parseFromISO(iso8601), formatString);
}

function parseFromISO(isoDate, originalTimezone = null) {
    if (! isoDate) {
        return null;
    }

    const targetTimezone = DEFAULT_TIMEZONE;

    if (isoDate instanceof Date || typeof isoDate === 'number') {
        return utcToZonedTime(isoDate, targetTimezone);
    }

    const isoString = String(isoDate);
    const hasTimezone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(isoString);

    if (hasTimezone) {
        return utcToZonedTime(isoString, targetTimezone);
    }

    // Treat timezone-less strings as local time in the provided timezone (default Phoenix),
    // not the browser's local timezone.
    const sourceTimezone = originalTimezone || targetTimezone;
    const utcDate = zonedTimeToUtc(isoString, sourceTimezone);
    return utcToZonedTime(utcDate, targetTimezone);
}

function formatAmPmTime(iso8601) {
    return formatFromISO(iso8601,'h:mm aaaa');
}

export function formatTime(stopTime) {
    if (!stopTime) {
        return '';
    }

    return format(stopTime, 'h:mm aaaa');
}

function transformAmPmFrom24(time) {
    const [ampmTime, ampmPeriod] = format(parse(time, 'H:mm:ss', new Date()), 'h:mm a').split(' ');

    return {
        time: ampmTime,
        ampm: ampmPeriod.toUpperCase(),
    }
}

function getToday() {
    return startOfDay(new Date());
}

function getNow() {
    return new Date();
}

function parseDate(dateString) {
    const [year, month, day] = dateString.split('/');

    return startOfDay(new Date(year, month - 1, day));
}

function betweenDates(date, start, end) {
    const compareStart = (start) ? compareAsc(date, start) > -1 : true;
    const compareEnd = (end) ? compareAsc(end, date) > -1 : true;

    return compareStart && compareEnd;
}

export {
    parse,
    format,
    getNow,
    getToday,
    parseDate,
    betweenDates,
    parseFromISO,
    formatFromISO,
    formatAmPmTime,
    transformAmPmFrom24,
}
